import {css} from "@emotion/react";
import React, {useEffect, useState, ChangeEvent} from 'react';
import {Modal800CallLogsProps} from "../Modal800CallLogs";
import {columnModal, LineMark, rowModal} from "../../styles";
import {Button} from "../../../Button";
import {Modal, ModalProps} from "../../../Modal";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import MailIcon from '@mui/icons-material/Mail';
import {toast} from "react-toastify";
import moment from "moment";

export interface ModalPropsNotification extends ModalProps{
    title?: string;
    open: boolean;
    padding?: number | string;

    onClose?(): void;
}


export type ModalNotificationProps = {
    modalProps: ModalPropsNotification;
}

export const ModalNotification: React.FC<ModalNotificationProps> = ({ modalProps,}) => {
  const [checked, setChecked] = React.useState([""]);
  const [cced, setCced] = React.useState([""]);				
  const [isSelected, setIsSelected] = React.useState(false);
  const [selectedFile, setSelectedFile] = useState<File | undefined>();
  const [failed, setFailed] = useState(false);
  const [failedCheck, setFailedCheck] = useState(false);
  const [pending, setPending] = React.useState(false);
  
  const [caller, setCaller] = React.useState("");
  const [location, setLocation] = React.useState("");
  const [callDt, setCallDt] = React.useState("");
  const [callerContact, setCallerContact] = React.useState("");
  const [source, setSource] = React.useState("");
  const [mineNo, setMineNo] = React.useState("");
  const [mineName, setMineName] = React.useState("");
  const [parentCo, setParentCo] = React.useState("");
  const [mineLoc, setMineLoc] = React.useState("");
  const [loadType, setLoadType] = React.useState("");
  
  const handleToggle = (event: ChangeEvent<HTMLInputElement>, value: string) => {
    
    console.log("Hello.");
    console.log(event);
    console.log(value);

    const email = event.target.name;
    const toIndx = checked.indexOf(email)
    const ccIndx = cced.indexOf(email)
    const newTo = [...checked];
    const newCC = [...cced];
    
    if (value === 'to') {
      if (toIndx === -1) {
	newTo.push(email);
      }
      if (ccIndx != -1) {
	newCC.splice(ccIndx,1);
      }
    }
    else if (value === 'cc') {
      if (ccIndx === -1) {
	newCC.push(email);
      }
      if (toIndx != -1) {
	newTo.splice(toIndx,1);
      }
    } 
    const resultCC = newCC.filter(e => e);
    const resultTo = newTo.filter(e => e);
    setCced(resultCC);
    setChecked(resultTo);

    console.log("To List",resultTo);
    console.log("CC List",resultCC);
    
    /* const currentIndex = checked.indexOf(value);
    * const newChecked = [...checked];

    * if (currentIndex === -1) {
      *     newChecked.push(value);
      * } else {
	*     newChecked.splice(currentIndex, 1);
	* }
    * //filter initial empty value
    * const result =  newChecked.filter(e =>  e);
    * console.log("Contents",result)

    * setChecked(result); */
  };
  const changeHandler = (event: any) => {
    let file;

    if(event.target.files[0]) {
      file = event.target.files[0];
      setSelectedFile(file);
      setIsSelected(true);
    }

  }

  const resetStates = () => {
    setFailed(false);
    setIsSelected(false);
    setChecked([""]);
    setFailedCheck(false);
    setSelectedFile(undefined);
  }
  const baseUrl = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_KEY || "no-key";								  

  const onSubmit = () => {
    // console.log("CHECKED",checked)
    // console.log(selectedFile)
    if(checked.length > 0 && selectedFile && checked[0].includes('@')){
    //if(selectedFile){ 
      const formData = new FormData();

      formData.append('emails',JSON.stringify(checked));
      formData.append('ccs',JSON.stringify(cced));
      formData.append('filename',selectedFile.name);
      formData.append('type', selectedFile.type);
      formData.append('notificationFile', selectedFile);

      formData.append('caller',caller);
      formData.append('location',location);
      formData.append('call_dt',callDt);
      formData.append('caller_contact',callerContact);
      formData.append('source',source);
      formData.append('mine_no',mineNo);
      formData.append('mine_name',mineName);
      formData.append('parent_co',parentCo);
      formData.append('mine_loc',mineLoc);
      formData.append('load_type',loadType);
      
      setPending(true)
      fetch(
        baseUrl + "/api/call_logs/sendNotification",
        {
	  method: 'POST',
	  headers: { 'Authorization': apiKey },
          body: formData,
        }
      )
        .then((response) => {
          if (response.ok) {
            toast.success("Notification sent successfuly")
            modalProps.onClose?.();
          }else {
            toast.error("An unexpected error happened, couldnt send email")
            modalProps.onClose?.();
          }
          response.json()
        }
        )
        .then((result) => {
          // console.log(result)
        })
        .finally(() => setPending(false))
        .catch((error) => {
          toast.error("An unexpected error happened")
          // console.log(error)
        });
      resetStates();
    }else{;
      if(selectedFile === undefined)
        setFailed(true);
      if(checked.length <= 0 || !checked[0].includes('@') )
        setFailedCheck(true);

      toast.error("Error: Missing required fields")
    }
  }



  const data =[
    {"email":"gde@swa.com", "name": "Dave Emmitt (SWA)"},
    {"email":"epy@swa.com", "name": "Eun Yi (SWA)"},
    {"email":"wray@wrayesian.com", "name": "Wray Mills (SWA)"},
    {"email":"it@swa.com", "name": "(SWA)"},
    {"email":"Jeffrey.Barwick@nscorp.com", "name": "Jeffrey Barwick (ENV)"},
    {"email":"Kaitlin.Depping2@nscorp.com", "name": "Kaitlin Depping (ENV)"},
    {"email":"Matthew.Gernand@nscorp.com", "name": "Matt Gernand (LEG)"},
    {"email":"Rudy.Husband@nscorp.com", "name": "Rudy Husband (PA)"},
    {"email":"Timothy.Bentley@nscorp.com", "name": "Tim Bentley (VA)"},
    {"email":"Jason.Wazelle@nscorp.com", "name": "Jason Wazelle (OH)"},
    {"email":"Robert.Scoble@nscorp.com", "name": "Robert Scoble (OH)"},
    {"email":"Christopher.Hunsicker@nscorp.com", "name": "Christopher Hunsicker (PA)"},
    {"email":"Robert.Wood2@nscorp.com", "name": "Robert Wood (VA)"},
    {"email":"Troy.Carpenter@nscorp.com", "name": "Troy Carpenter (VA)"},
    {"email":"Brad.Yeatts@nscorp.com", "name": "Brad Yeatts (MKT)"},
    {"email":"Jason.MacMackin@nscorp.com", "name": "Jason MacMackin (MKT)"},
    {"email":"Courtney.Siffre@nscorp.com", "name": "Courtney Siffre (MKT)"},

  ];

  useEffect(() => {
    if(modalProps.open == false)
      resetStates()
  }, [modalProps]);

  return (
    <Modal width={600} padding={"10px 35px 35px 48px"} title="Send Notification"  {...modalProps}>
      <div>
        <div css={columnModal}>
          <React.Fragment>
            <h3>Upload File</h3>
            <div style={{display:'flex'}}>
              <input  type="file" name="file" onChange={changeHandler}/>
              {failed && <p style={{color:'red',margin:0}}>*Required</p>}
            </div>
            <div style={{display:'flex', alignItems:'center'}}>
              <h3>Select recipients</h3>
              {failedCheck && <p style={{color:'red',margin:0,marginLeft:'132px'}}>*Required</p>}
            </div>
            <List sx={{width: '100%', maxWidth: 400, bgcolor: 'background.paper'}}>
              {data.map(item => {
                const labelId = `checkbox-list-label-${item.email}`;

                return (
                  <>
                    <p style={{margin:0}}>{item.name}</p>
                    <ListItem
                      key={item.email}
                      secondaryAction={
                        <IconButton edge="end" aria-label="comments">
                          <MailIcon />
                        </IconButton>
                      }
                      disablePadding
                    >
		      <RadioGroup
			row
			aria-labelledby="demo-radio-buttons-group-label"
					 name={item.email}
					 onChange={handleToggle}
		      >
			<FormControlLabel value="to" control={<Radio />} label="To" />
			<FormControlLabel value="cc" control={<Radio />} label="CC" />
		      </RadioGroup>
                      {/* <ListItemButton role={undefined} onClick={handleToggle(item.email)} dense>
			  <ListItemIcon>
			  To:
                          <Checkbox
                          edge="start"
                          checked={checked.indexOf(item.email) !== -1}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{ 'aria-labelledby': labelId }}
			  />
			  </ListItemIcon>
			  </ListItemButton>
			  <ListItemButton role={undefined} onClick={handleCCToggle(item.email)} dense>
			  <ListItemIcon>
			  CC:                                                                              <Checkbox									edge="start"
			  checked={checked.indexOf(item.email) !== -1}
			  tabIndex={-1}
			  disableRipple
			  inputProps={{ 'aria-labelledby': labelId }}
			  />
			  </ListItemIcon>
			  </ListItemButton> */}
                      <ListItemText id={labelId} primary={`${item.email}`} />
                    </ListItem>
                  </>
                );
              })}

	    </List>

	    <TextField
	      hiddenLabel
	      id="caller"
	      variant="filled"
	      size="small"
	      defaultValue="Caller"
	      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
		setCaller(event.target.value);
	      }}
	    />
	    <TextField
	      hiddenLabel
	      id="location"
	      variant="filled"
	      size="small"
	      defaultValue="Location"
	      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
		setLocation(event.target.value);
	      }}
	    />
	    <TextField
	      hiddenLabel
	      id="calldt"
	      variant="filled"
	      size="small"
	      defaultValue="Date YYYY-MM-DD"
	      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
		setCallDt(event.target.value);
	      }}
	    />
	    <TextField
	      hiddenLabel
	      id="callercontact"
	      variant="filled"
	      size="small"
	      defaultValue="Caller's Contact"
	      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
		setCallerContact(event.target.value);
	      }}
	    />
	    <br/>
	    <br/>
	    <TextField
	      hiddenLabel
	      id="source"
	      variant="filled"
	      size="small"
	      defaultValue="Source"
	      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
		setSource(event.target.value);
	      }}
	    />
	    <TextField
	      hiddenLabel
	      id="mineNo"
	      variant="filled"
	      size="small"
	      defaultValue="Mine #"
	      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
		setMineNo(event.target.value);
	      }}
	    />
	    <TextField
	      hiddenLabel
	      id="mineName"
	      variant="filled"
	      size="small"
	      defaultValue="Mine Name"
	      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
		setMineName(event.target.value);
	      }}
	    />
	    <TextField
	      hiddenLabel
	      id="parentCo"
	      variant="filled"
	      size="small"
	      defaultValue="Parent Co"
	      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
		setParentCo(event.target.value);
	      }}
	    />
	    <TextField
	      hiddenLabel
	      id="MineLoc"
	      variant="filled"
	      size="small"
	      defaultValue="Mine Location"
	      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
		setMineLoc(event.target.value);
	      }}
	    />
	    <TextField
	      hiddenLabel
	      id="LoadType"
	      variant="filled"
	      size="small"
	      defaultValue="Load Type"
	      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
		setLoadType(event.target.value);
	      }}
	    />
	    
	    {/* Caller: <input type="text"/>
		Location: <input type="text"/>
		Call Date/Time: <input type="text"/>
		Caller's Contact: <input type="text"/><br/>
		The source was traced to:<br/>
		Mine Number: <input type="text"/>
		Mine Name: <input type="text"/>
		Parent Company: <input type="text"/>
		Location: <input type="text"/>
		Load Type: <input type="text"/> */}
	    
            <div style={{display:'flex', alignItems: 'center'}}>
              <Button onClick={onSubmit} style={{marginTop:25}}>Submit</Button>
              {pending && <p style={{color:'green',margin:0, marginTop:25 , marginLeft:20}}>Sending notifications..</p>}
            </div>
          </React.Fragment>
        </div>
      </div>
    </Modal>
  );

};
